'use client';

import { useEffect, useState } from 'react';
import FreeStar from '@/components/freeStar';

interface ResponsiveFreeStarProps {
  position: 'top' | 'right' | 'right_secondary' | 'bottom';
}

export default function ResourceListFreeStarAd({
  position,
}: ResponsiveFreeStarProps) {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    setIsDesktop(window?.innerWidth >= 1024);
  }, []);

  const LoadAd = () => {
    if (isDesktop) {
      switch (position) {
        case 'top':
          return (
            <FreeStar placementName="signupgenius_Desktop_Resources_Main_728x90_Top" />
          );
        case 'right':
          return (
            <FreeStar placementName="signupgenius_Desktop_Resources_Main_300x600_Right" />
          );
        case 'right_secondary':
          return (
            <FreeStar placementName="signupgenius_Desktop_Resources_Main_300x250_Right_secondary" />
          );
        case 'bottom':
          return (
            <FreeStar placementName="signupgenius_Desktop_Resources_Main_810x250_Bot" />
          );
      }
    } else {
      switch (position) {
        case 'top':
          return (
            <FreeStar placementName="signupgenius_Desktop_Resources_Main_320x50_Top" />
          );
        case 'bottom':
          return (
            <FreeStar placementName="signupgenius_Desktop_Resources_Main_320x50_Bot" />
          );
        default:
          return null;
      }
    }
  };

  return LoadAd();
}
